import './FileEditModal.scss';

export { default } from './FileEditModal';
